import { z } from "zod";

export const seo = z.object({
  title: z.string().nullish(),
  description: z.string().nullish(),
  keywords: z.string().nullish(),
  customSeoLinkPath: z.string().nullish(),
  image: z.string().nullish(),
});
